import { RefreshCw, CheckCircle, AlertCircle } from "lucide-react";

export const RefreshIndicator = ({ status, isRefreshing }) => {
  const getStatusLabel = (state) => {
    const labels = {
      queued: "Queued",
      sourcing: "Fetching sources...",
      curating: "Curating content...",
      interpreting: "Interpreting...",
      adapting: "Adapting content...",
      structuring: "Structuring...",
      indexing: "Indexing...",
      publishing: "Publishing...",
      completed: "Up to date",
      failed: "Refresh failed"
    };
    return labels[state] || state;
  };

  if (status?.status === "completed" && !isRefreshing) return null;

  return (
    <div className="fixed bottom-20 md:bottom-4 right-4 z-40" data-testid="refresh-indicator">
      <div className="bg-[#112240] border border-white/10 rounded-xl shadow-lg p-4 flex items-center gap-3 min-w-[200px]">
        {isRefreshing ? (
          <div className="w-8 h-8 rounded-full bg-[#14B8A6]/10 flex items-center justify-center">
            <RefreshCw className="w-4 h-4 text-[#14B8A6] animate-spin" />
          </div>
        ) : status?.status === "failed" ? (
          <div className="w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center">
            <AlertCircle className="w-4 h-4 text-red-400" />
          </div>
        ) : (
          <div className="w-8 h-8 rounded-full bg-[#14B8A6]/10 flex items-center justify-center">
            <CheckCircle className="w-4 h-4 text-[#14B8A6]" />
          </div>
        )}
        <div className="flex-1">
          <p className={`text-sm font-medium ${
            status?.status === "completed" ? "text-[#14B8A6]" : 
            status?.status === "failed" ? "text-red-400" : "text-[#14B8A6]"
          }`}>
            {getStatusLabel(status?.status)}
          </p>
          {isRefreshing && status?.progress > 0 && (
            <div className="mt-1 h-1 bg-white/[0.06] rounded-full overflow-hidden">
              <div className="h-full bg-[#14B8A6] transition-all duration-500" style={{ width: `${status.progress * 100}%` }} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
